import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { money } from "@/lib/api";

export const ServiceCard = ({ svc }) => (
  <article
    data-testid={`inspection-card-${svc.id}`}
    className="group flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-20px_rgba(11,19,43,0.35)]"
  >
    <div className="relative h-48 overflow-hidden">
      <img src={svc.image} alt={svc.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      <div className="absolute bottom-3 left-3 rounded-full bg-white/95 px-3 py-1.5 shadow-sm backdrop-blur">
        <span className="text-[10px] uppercase tracking-widest text-slate-500">From </span>
        <span data-testid={`inspection-price-${svc.id}`} className="font-display text-lg font-bold text-[#0B132B]">{money(svc.base_price)}</span>
      </div>
    </div>
    <div className="flex flex-1 flex-col p-6">
      <h3 className="font-display text-xl font-bold text-[#0B132B]">{svc.name}</h3>
      <p className="mt-2 text-sm leading-relaxed text-slate-500">{svc.description}</p>
      <p className="mt-5 font-mono-x text-[10px] uppercase tracking-widest text-gold">What's included</p>
      <ul className="mt-2 flex-1 space-y-1.5">
        {svc.includes.map((it) => (
          <li key={it} className="flex gap-2 text-sm text-slate-600">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-gold" /> {it}
          </li>
        ))}
      </ul>
      <Link
        to={`/property-inspections/book?service=${svc.id}`}
        data-testid={`inspection-book-${svc.id}`}
        className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-[#0B132B] px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-gold hover:text-[#0B132B]"
      >
        Book Now <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  </article>
);

export const ServiceGrid = ({ services }) => (
  <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
    {services.map((s) => <ServiceCard key={s.id} svc={s} />)}
  </div>
);
